export interface TranslatorParams
{
	translationFile ?: string;
	translations    ?: Object;
	onReady         ?: Function;
	onError         ?: Function;
}

/**
 * A translator class that works from a language file or a pre-defined translation
 * array.
 */
export class Translator
{
	TAG = "[Sxc.Translator]";

	private data = {};

	constructor(private params : TranslatorParams)
	{
		if (this.params.translationFile)
		{
			$.getJSON(this.params.translationFile, (r) => {
				this.data = r;
				if (this.params.onReady) this.params.onReady();
			}).fail(() => {
				if (this.params.onError) this.params.onError();
			});
		}
		else if (this.params.translations)
		{
			this.data = this.params.translations;
			if (this.params.onReady) this.params.onReady();
		}
		else
		{
			throw "Sxc.Translator: Neither translationFile nor translation is specified in the params."
		}
	}

	isReady() {
		return !!this.data;
	}

	t(key : string, params = {}) : string
	{
		let text = key in this.data ? this.data[key] : key;
		// let pKeys = Object.keys(params);

		if (params) {
			text = text.replace(/\{\{(.*?)\}\}/g, (a, b) => {
				return b in params ? params[b] : a;
			});
		}

		text = text.replace(/\[\[(.*?)\]\]/g, (a, b) => {
			return this.t(b, params)
		});

		let sep = "_sep" in params ? params["_sep"] : null;
		if (sep) text = text.split("|").join(sep);

		return text;
	}

	add(name : string, value : string):void {
		this.data[name] = value;
	}

	lang()
	{
		return this.t("language_code");
	}
}
